import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import FloatingButtonAndPrice from 'modules/plan/components/FloatingButtonAndPrice/index.js'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import { getPremiumYearlyUrlRouteUtil } from 'modules/training/modules/subscription/utils/get-premium-yearly-url/index.js'
import pushRouterAction from 'modules/router/actions/push/index.js'
import { hasFreeTrialEndedUserSelect } from 'modules/training/modules/training-users/selectors/has-free-trial-ended/index.js'
import { defineMessages } from 'react-intl'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import {
  SUBSCRIPTION_PLAN,
  SUBSCRIPTION_PLAN_TO_MONTHLY_PRICE
} from '@gymaholic/packages'

const ANALYTIC_EVENT = {
  WORKOUT_GET_PREMIUM: 'WORKOUT_GET_PREMIUM'
}

const messages = defineMessages({
  tryPremiumFree: {
    id: 'WorkoutFloatingGetPremiumButton.tryPremiumFree',
    defaultMessage: 'START FREE TRIAL ⭐'
  },
  getPremium: {
    id: 'WorkoutFloatingGetPremiumButton.getPremium',
    defaultMessage: 'GET PREMIUM ⭐'
  },
  zeroPrice: {
    id: 'WorkoutFloatingGetPremiumButton.zeroPrice',
    defaultMessage: '0 today'
  },
  premiumPrice: {
    id: 'WorkoutFloatingGetPremiumButton.premiumPrice',
    defaultMessage: '{price}'
  }
})

export function WorkoutFloatingGetPremiumButton () {
  const intl = useIntl()
  const hasFreeTrialEnded = useSelector(hasFreeTrialEndedUserSelect)
  const dispatch = useDispatch()

  const handleClickGetPremium = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.WORKOUT_GET_PREMIUM)
    const url = getPremiumYearlyUrlRouteUtil()
    dispatch(pushRouterAction(url))
  }

  const priceLabel = hasFreeTrialEnded
    ? formatMessageIntlUtil(intl, messages.premiumPrice, { price: SUBSCRIPTION_PLAN_TO_MONTHLY_PRICE[SUBSCRIPTION_PLAN.PREMIUM_YEARLY_2025] })
    : formatMessageIntlUtil(intl, messages.zeroPrice)

  const ctaLabel = hasFreeTrialEnded
    ? formatMessageIntlUtil(intl, messages.getPremium)
    : formatMessageIntlUtil(intl, messages.tryPremiumFree)

  return (
    <FloatingButtonAndPrice
      price={priceLabel}
      buttonText={ctaLabel}
      onClick={handleClickGetPremium}
    />
  )
}
